import { useEffect, useState } from "react";
import axios from "axios";
import Navigation from "@/components/site/Navigation";
import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import About from "@/components/site/About";
import ClinicTour from "@/components/site/ClinicTour";
import Doctor from "@/components/site/Doctor";
import Gallery from "@/components/site/Gallery";
import Testimonials from "@/components/site/Testimonials";
import BookingContact from "@/components/site/BookingContact";
import Footer from "@/components/site/Footer";
import ChatAssistant from "@/components/site/ChatAssistant";
import { CLINIC } from "@/lib/clinic";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Home() {
  const [waNumber, setWaNumber] = useState(CLINIC.phoneDial.replace(/[^0-9]/g, ""));

  useEffect(() => {
    let active = true;
    axios
      .get(`${API}/clinic-info`)
      .then(({ data }) => {
        if (active && data?.whatsapp_number) setWaNumber(String(data.whatsapp_number));
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);

  return (
    <div data-testid="page-home" className="relative">
      <Navigation waNumber={waNumber} />
      <main>
        <Hero waNumber={waNumber} />
        <Services />
        <About />
        <ClinicTour />
        <Doctor />
        <Gallery />
        <Testimonials />
        <BookingContact waNumber={waNumber} />
      </main>
      <Footer waNumber={waNumber} />
      <ChatAssistant waNumber={waNumber} />
    </div>
  );
}
